import { render, staticRenderFns } from "./DetalheExtradoSomentoClienteProdutosFocar.vue?vue&type=template&id=4dd891b7&scoped=true&"
import script from "./DetalheExtradoSomentoClienteProdutosFocar.vue?vue&type=script&lang=js&"
export * from "./DetalheExtradoSomentoClienteProdutosFocar.vue?vue&type=script&lang=js&"
import style0 from "./DetalheExtradoSomentoClienteProdutosFocar.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./DetalheExtradoSomentoClienteProdutosFocar.vue?vue&type=style&index=1&id=4dd891b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd891b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardActions,VCol,VContainer,VIcon,VRow,VTooltip})
